import { DateTime } from 'luxon'
import memoize from './memoize.utils'

export const dateToLocaleString = (date: DateTime): string =>
    date.toLocaleString({ day: '2-digit', month: '2-digit', year: 'numeric' })

export const dateStringToLocaleString = memoize(
    (date: string, returnLuxonDatetime = false): string | number | DateTime => {
        if (returnLuxonDatetime) return DateTime.fromISO(date)
        const dateObj = new Date(date)
        const dateObjLuxon = DateTime.fromJSDate(dateObj)
        // if datetime is in the future, return 1
        // if (dateObjLuxon > DateTime.local()) return 1
        // if date is today, return 0
        // if (dateObjLuxon.toISODate() === DateTime.local().toISODate()) return 0
        // response example: 24.08.23, 12:00
        return dateObjLuxon.toLocaleString({
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        })
    }
)
